import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import MaterialCategoryForm from "components/form/MaterialCategoryForm";

import { SaveContextProvider } from "context/save";

import { useMaterialCategoryId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Categoria modificata con successo",
        errorMsg: "Errore nella modifica della categoria",
        navigateTo: { link: "/gestione-materiali/categorie" },
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaCatMateriale() {
    const materialCategoryId = useMaterialCategoryId();

    return (
        <GridColumn>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica Categoria Materiale</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <MaterialCategoryForm materialCategoryId={materialCategoryId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaCatMateriale;
